import { render, staticRenderFns } from "./addCertificateBindView.vue?vue&type=template&id=45f3d40e&"
import script from "./addCertificateBindView.vue?vue&type=script&lang=js&"
export * from "./addCertificateBindView.vue?vue&type=script&lang=js&"
import style0 from "./addCertificateBindView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports